<template>
    <div class="flex">
        <div>
            <a :href="`/strings-layouts/${stringLayout.id}`"
               class="px-2 w-1/3 hover:text-blue-600"
               v-if="policies.view"
               v-tooltip="'Apri'"
            >
                <i class="far fa-folder-open"></i>
            </a>
        </div>
        <div v-show="!underRevision && stringLayout.status == 'current'">
            <a :href="`/strings-layouts/${stringLayout.id}/revision`"
               class="px-2 w-1/3 hover:text-blue-600"
               v-if="policies.revision"
               v-tooltip="'Aggiungi Revisione'"
            >
                <i class="fas fa-registered"></i>
            </a>
        </div>
        <div v-show="underRevision && stringLayout.status == 'current'">
            <a :href="url" class="px-2 w-1/3 text-aitems-700 hover:text-aitems-700-dark"
               v-if="policies.update"
               v-tooltip="'Apri Bozza Revisione'"
            >
                <i class="fas fa-external-link-alt"></i>
            </a>
        </div>
        <div v-show="stringLayout.status == 'draft' || stringLayout.status == 'new'">
            <a :href="`/strings-layouts/edit/${stringLayout.id}`" class="px-2 w-1/3 text-aitems-700 hover:text-aitems-700-dark"
               v-if="policies.update"
               v-tooltip="'Apri Bozza Revisione'"
            >
                <i class="fas fa-external-link-alt"></i>
            </a>
        </div>
        <div v-show="!underRevision && stringLayout.status == 'current'">
            <a href="#"
               class="px-2 w-1/3 hover:text-blue-600"
               v-if="policies.create"
               v-tooltip="'Duplica'"
               @click.prevent="$emit('duplicate', stringLayout)"
            >
                <i class="far fa-clone"></i>
            </a>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            stringLayout: { required: true },
            policies: { required: true },
            underRevision: { default: false}
        },

        watch: {
            underRevision(newValue) {
                if (newValue) {
                    this.fetchParentId();
                    return
                }
                this.url = ''
            }
        },

        data() {
            return{
                url: ''
            }
        },

        mounted() {
            this.fetchParentId()
        },

        methods: {
            fetchParentId() {
                if (this.underRevision && this.stringLayout.status == 'current') {
                    axios.get(`/strings-layouts/revision/${this.stringLayout.id}`)
                        .then(({data}) => {
                            this.url = `/strings-layouts/edit/${data.id}`
                        })

                }
            }
        }
    }
</script>
